// check-all_controller.js

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mainCheckbox", "selectContainer"];

  connect() {
    this._optionCheckboxes = this.optionCheckboxes();
    this.syncFromOptions();
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    const isChecked = this.mainCheckboxTarget.checked;
    this._optionCheckboxes.forEach((box) => {
      box.checked = isChecked;
    });
  }

  syncFromOptions() {
    const allChecked =
      this._optionCheckboxes.length > 0 &&
      this._optionCheckboxes.every((box) => box.checked);

    this.mainCheckboxTarget.checked = allChecked;
  }

  optionCheckboxes() {
    return Array.from(
      this.selectContainerTarget.querySelectorAll("input[type='checkbox']")
    );
  }
}
